export default {
  // AUTH
  'Ulams\\Auth\\Events\\AccountBlocked': 'Account blocked',
  'Ulams\\Auth\\Events\\AccountConfirmed': 'Account confirmed',
  'Ulams\\Auth\\Events\\AccountDeleted': 'Account deleted',
  'Ulams\\Auth\\Events\\AccountMustBeEnableByAdmin': 'Account must be enable by admin',
  'Ulams\\Auth\\Events\\AccountRegistered': 'Account registered',
  'Ulams\\Auth\\Events\\ForgotPassword': 'Forgot password',
  'Ulams\\Auth\\Events\\Login': 'Login',
  'Ulams\\Auth\\Events\\Logout': 'Logout',
  'Ulams\\Auth\\Events\\PasswordChanged': 'Password changed',
  'Ulams\\Auth\\Events\\ResetPassword': 'Reset password',
  'Ulams\\Auth\\Events\\UserAddedToGroup': 'User added to group',
  'Ulams\\Auth\\Events\\UserRemovedFromGroup': 'User removed from group',
  // SETTINGS
  'Ulams\\Settings\\Events\\SettingPackageConfigUpdated': 'Setting package config updated',
  // CSV USER
  'Ulams\\CsvUsers\\Events\\UlamsImportedNewUserTemplateEvent': 'Imported new user template event',
  // TOPIC
  'Ulams\\TopicTypes\\Events\\TopicTypeChanged': 'Topic type changed',
  // CONSULTATIONS
  'Ulams\\Consultations\\Events\\ApprovedTerm': 'Consultation approved term',
  'Ulams\\Consultations\\Events\\ApprovedTermWithTrainer':
    'Consultation approved term with trainer',
  'Ulams\\Consultations\\Events\\ChangeTerm': 'Consultation change term',
  'Ulams\\Consultations\\Events\\RejectTerm': 'Consultation reject term',
  'Ulams\\Consultations\\Events\\RejectTermWithTrainer': 'Consultation reject term with trainer',
  'Ulams\\Consultations\\Events\\ReminderAboutTerm': 'Consultation reminder about term',
  'Ulams\\Consultations\\Events\\ReminderTrainerAboutTerm':
    'Consultation reminder trainer about term',
  'Ulams\\Consultations\\Events\\ReportTerm': 'Consultation report term',
  // WEBINAR
  'Ulams\\Webinar\\Events\\ReminderAboutTerm': 'Webinar reminder about term',
  'Ulams\\Webinar\\Events\\WebinarTrainerAssigned': 'Webinart trainer assigned',
  'Ulams\\Webinar\\Events\\WebinarTrainerUnassigned': 'Webinar trainer unassigned',
  // PAYMENT
  'Ulams\\Payments\\Events\\PaymentCancelled': 'Payment cancelled',
  'Ulams\\Payments\\Events\\PaymentFailed': 'Payment failed',
  'Ulams\\Payments\\Events\\PaymentRegistered': 'Payment registered',
  'Ulams\\Payments\\Events\\PaymentSuccess': 'Payment success',
  // COURSE
  'Ulams\\Courses\\Events\\CourseAccessFinished': 'Course access finished',
  'Ulams\\Courses\\Events\\CourseAccessStarted': 'Course access started',
  'Ulams\\Courses\\Events\\CourseAssigned': 'Course assigned',
  'Ulams\\Courses\\Events\\CourseDeadlineSoon': 'Course deadline soon',
  'Ulams\\Courses\\Events\\CoursedPublished': 'Coursed published',
  'Ulams\\Courses\\Events\\CourseFinished': 'Course finished',
  'Ulams\\Courses\\Events\\CourseStarted': 'Course started',
  'Ulams\\Courses\\Events\\CourseStatusChanged': 'Course status changed',
  'Ulams\\Courses\\Events\\CourseTutorAssigned': 'Course tutor assigned',
  'Ulams\\Courses\\Events\\CourseTutorUnassigned': 'Course tutor unassigned',
  'Ulams\\Courses\\Events\\CourseUnassigned': 'Course unassigned',
  'Ulams\\Courses\\Events\\TopicFinished': 'Topic finished',
  // STATIONARY EVENT
  'Ulams\\StationaryEvents\\Events\\StationaryEventAssigned': 'Stationary event assigned',
  'Ulams\\StationaryEvents\\Events\\StationaryEventUnassigned': 'Stationary event unassigned',
  'Ulams\\StationaryEvents\\Events\\StationaryEventAuthorAssigned':
    'Stationary event author assigned',
  'Ulams\\StationaryEvents\\Events\\StationaryEventAuthorUnassigned':
    'Stationary event author unassigned',
  // CART
  'Ulams\\Cart\\Events\\AbandonedCartEvent': 'Abandoned cart event',
  'Ulams\\Cart\\Events\\OrderCancelled': 'Cart order cancelled',
  'Ulams\\Cart\\Events\\OrderCreated': 'Cart order created',
  'Ulams\\Cart\\Events\\OrderPaid': 'Cart order paid',
  'Ulams\\Cart\\Events\\ProductableAttached': 'Cart productable attached',
  'Ulams\\Cart\\Events\\ProductableDetached': 'Cart productable detached',
  'Ulams\\Cart\\Events\\ProductAddedToCart': 'Product added to cart',
  'Ulams\\Cart\\Events\\ProductAttached': 'Cart product attached',
  'Ulams\\Cart\\Events\\ProductBought': 'Cart product bought',
  'Ulams\\Cart\\Events\\ProductDetached': 'Cart product detached',
  'Ulams\\Cart\\Events\\ProductRemovedFromCart': 'Product removed from cart',
  // TEMPLATES
  'Ulams\\Templates\\Events\\ManuallyTriggeredEvent': 'Template manually triggered event',
  // ASSIGN WITHOUT ACCOUNT
  'Ulams\\AssignWithoutAccount\\Events\\AssignToProductable':
    'Assign to productable without account',
  'Ulams\\AssignWithoutAccount\\Events\\AssignToProduct': 'Assign to product without account',
  // Youtube
  'Ulams\\Youtube\\Events\\YtProblem': 'YouTube error',
  // COURSE ACCESS
  'Ulams\\CourseAccess\\Events\\CourseAccessEnquiryAdminCreatedEvent':
    'Course access enquiry admin created event',
  // TASKS
  'Ulams\\Tasks\\Events\\TaskAssignedEvent': 'Task assigned event',
  'Ulams\\Tasks\\Events\\TaskCompleteUserConfirmationEvent':
    'Task complete user confirmation event',
  'Ulams\\Tasks\\Events\\TaskCompleteRequestEvent': 'Task complete request event',
  'Ulams\\Tasks\\Events\\TaskOverdueEvent': 'Task overdue event',
  'Ulams\\Tasks\\Events\\TaskIncompleteEvent': 'Task incomplete event',
  'Ulams\\Tasks\\Events\\TaskNoteCreatedEvent': 'Task note created event',
  // CONSULTATION ACCESS
  'Ulams\\ConsultationAccess\\Events\\ConsultationAccessEnquiryAdminCreatedEvent':
    'Consultation access enquiry admin created event',
  'Ulams\\ConsultationAccess\\Events\\ConsultationAccessEnquiryDisapprovedEvent':
    'Consultation access enquiry disapproved event',
  'Ulams\\ConsultationAccess\\Events\\ConsultationAccessEnquiryApprovedEvent':
    'Consultation access enquiry approved event',
  // TOPIC TYPE PROJECT
  'Ulams\\TopicTypeProject\\Events\\ProjectSolutionCreatedEvent': 'Project solution created event',
};
